import { memo } from "react";
import tw, { styled } from "twin.macro";

const Base = tw.div`bg-white w-full h-[1px] my-4`;

interface Props {
  vertical?: boolean;
  className?: string;
}

export const Divider = ({ vertical, ...rest }: Props) => {
  if (vertical) {
    return <Base css={tw`w-[1px] h-full mx-4`} {...rest} />;
  } else {
    return <Base {...rest} />;
  }
};

/**
 * @deprecated
 */
type DEPRECATED_Props = {
  color?: string;
  width?: string;
  height?: string;
  bold?: number;
  margin?: number[];
  vertical?: boolean;
};

/**
 * @deprecated
 */
const DEPRECATED_Divider = memo(styled.div<DEPRECATED_Props>`
  background: ${({ color }) => (color ? color : "#fff")};
  width: ${({ vertical, width, bold }) => {
    if (vertical) {
      return bold ? `${bold}px` : "1px";
    } else {
      return width ? width : "100%";
    }
  }};
  height: ${({ vertical, height, bold }) => {
    if (vertical) {
      return height ? height : "100%";
    } else {
      return bold ? `${bold}px` : "1px";
    }
  }};
  margin: ${({ vertical, margin }) => {
    if (vertical) {
      return margin ? margin.map((value) => `${value}px`).join(" ") : "0 16px";
    } else {
      return margin ? margin.map((value) => `${value}px`).join(" ") : "16px 0";
    }
  }};
`);

export default DEPRECATED_Divider;
